import { render } from "./PartnerNotValidUser.vue?vue&type=template&id=4f785ae6&scoped=true"
import script from "./PartnerNotValidUser.vue?vue&type=script&lang=js"
export * from "./PartnerNotValidUser.vue?vue&type=script&lang=js"

import "./PartnerNotValidUser.vue?vue&type=style&index=0&id=4f785ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f785ae6"]])

export default __exports__